import { render, staticRenderFns } from "./Verticalnav.vue?vue&type=template&id=973e181a&"
import script from "./Verticalnav.vue?vue&type=script&lang=js&"
export * from "./Verticalnav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports